import { render, staticRenderFns } from "./ShortTextSettings.vue?vue&type=template&id=4f772b9d&scoped=true"
import script from "./ShortTextSettings.vue?vue&type=script&lang=js"
export * from "./ShortTextSettings.vue?vue&type=script&lang=js"
import style0 from "./ShortTextSettings.vue?vue&type=style&index=0&id=4f772b9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f772b9d",
  null
  
)

export default component.exports